export const navLinks = [
  { label: '首页', path: '/', icon: 'ri-home-4-line' },
  { label: '平台指南', path: '/category/guide', icon: 'ri-compass-3-line' },
  { label: '最新动态', path: '/category/news', icon: 'ri-flashlight-line' },
  { label: '帮助中心', path: '/category/help', icon: 'ri-question-line' },
  { label: '关于我们', path: '/about', icon: 'ri-information-line' },
];

export const footerLinks = {
  platform: {
    title: '平台导航',
    links: [
      { label: '平台首页', path: '/' },
      { label: '使用指南', path: '/category/guide' },
      { label: '最新动态', path: '/category/news' },
      { label: '帮助中心', path: '/category/help' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about#intro' },
      { label: '用户口碑', path: '/about#reputation' },
      { label: '联系方式', path: '/about#contact' },
    ],
  },
  legal: {
    title: '法律声明',
    links: [
      { label: '服务条款', path: '/article/terms' },
      { label: '隐私政策', path: '/article/privacy' },
      { label: '免责声明', path: '/article/disclaimer' },
    ],
  },
};